// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yMYI","left":"styles_left__rspXc","desktopActions":"styles_desktopActions__Rcgb6","title":"styles_title__1M0C3"};